import { addToCart } from "../redux/cart/cartAction";
import { useDispatch, useSelector } from "react-redux";
import { productList } from "../redux/product/productAction";
import { useEffect } from "react";

function Main() {
  // Initialize dispatch function from Redux
  const dispatch = useDispatch();

  // Select product data and loading state from Redux store
  const { data, loading } = useSelector((state) => state.productData);

  // Fetch product list on component mount
  useEffect(() => {
    dispatch(productList());
  }, [dispatch]);

  // Show loading spinner while fetching data
  if (loading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  // Render product list
  return (
    <div className="App">
      <div className="product-container">
        {Array.isArray(data) ? (
          data.map((item, index) => (
            <div key={index} className="product-item">
              <img className="product-image" src={item.image} alt={item.name} />
              <div className="product-title">Name: {item.title}</div>
              <div className="product-category">Category: {item.category}</div>
              <div className="product-price">Price: {item.price}</div>
              <div className="product-description">
                Description: {item.description}
              </div>
              <div className="product-rating">
                Rating: {item.rating.rate} ⭐ ({item.rating.count} reviews)
              </div>
              <div>
                <button onClick={() => dispatch(addToCart(item))}>
                  🛒 Add to Cart
                </button>
              </div>
            </div>
          ))
        ) : (
          <p>😕 No products found!</p>
        )}
      </div>
    </div>
  );
}

export default Main;
